
export const BACKEND_URL = 'https://portail.bcepharma.com/';
export const BACKEND_URL_PORTAIL = 'https://back-portail.bcepharma.com/';
export const BACKEND_URL_LOG = 'https://back-quess-360.bcepharma.com/';
export const BACKEND_URL_DOC = 'https://back-fm.bcepharma.com/api/';
export const LOG_URL = 'https://quess-360.bcepharma.com';
export const DOC_URL = 'https://filemanager.bcepharma.com';
export const COMPOUND_URL = 'https://quess-compounding.bcepharma.com';
export const MACKESSON_URL_AUTH = 'https://mckesson.okta.com/oauth2/aussdpmoe7dnFuggr357/v1/authorize';
export const CLIENT_ID ='0oa1ldkqjjj3ZtiS0358';
export const PASSAPI ='BCEpha5*';
export const USERAPI ='apibce';
export const LMS_URL ='https://bce-acceptation.connexence.com/resto/cnx/api1/usager/';
 
